import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import logo from '../../logo.svg';
import '../../App.css';

const RenderLogin = (props) => {

  return (
    <Container id="main-container" className="d-grid h-100">
      <Form onSubmit={props.handleSubmit} id="sign-in-form" className="text-center p-3 w-100">
        <img className="App-logo"
          src={logo}
          alt="React Logo"
        />
        <h1 className="mb-3 fs-3 fw-normal">Please sign in</h1>

        <Form.Group controlId="sign-in-email-address">
          <Form.Control
            type="email" size="lg"
            placeholder="Email address"
            className="position-relative"
            autoComplete="off"
            onChange={(e) => props.setUser(e.target.value)}
            value={props.user}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="sign-in-password">
          <Form.Control
            type="password"
            size="lg"
            placeholder="Password"
            autoComplete="off"
            className="position-relative"
            onChange={(e) => props.setPwd(e.target.value)}
            value={props.pwd}
            required
          />
        </Form.Group>

        {/* <Form.Group className="d-flex justify-content-center mb-4" controlId="remember-me">
          <Form.Check label="Remember me" />
        </Form.Group> */}

        {props.errMsg &&
          <Alert
            variant="danger"
          >
            {props.errMsg}
          </Alert>
        }
        <div className="d-grid">
          <Button type="submit" variant="primary" size="lg">Sign in</Button>
        </div>

        <p className="mt-5 text-muted">&copy; 2022</p>
      </Form>
    </Container>
  )
}

export default RenderLogin
